export default "__VITE_ASSET__DflN4WbX__"